import React from 'react';
import Header from '../../components/Header';
import { EventsTrigger } from 'src/components/EventsTrigger/EventsTrigger';
import CustomersBar from '../../components/CustomersBar';
import Audits from '../../components/Audits';
import BetTicker from '../../components/BetTicker';
import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import { PepXmlRouterWrapper} from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';

class BetTickerPage extends React.Component {
    render() {
        return (
            <div className='content bet-ticker-page'>
                <Header />
                <BetTicker />
                <CustomersBar />
                <EventsTrigger />
                <Audits />
                <ComplianceAudits />
                <PepXmlRouterWrapper/>
            </div>
        );
    }
}

export default BetTickerPage;
